import asUrlString from '../utils/asUrlString';
export const getCurrencies = () => asUrlString('/currencies');
